module.exports = __webpack_public_path__ + "img/home--why-choose.f529f49d.jpg";